export default {
  on: {
    pageBeforeIn: function () {
      this.$app.statusbar.setBackgroundColor('#ffffff');
      this.$app.statusbar.setTextColor('black');
    }
  },
  id: 'b6bb5d07a4',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page notification-page" data-name="notification">\n        <div class="navbar">\n            <div class="navbar-bg"></div>\n            <div class="navbar-inner sliding">\n                <div class="left">\n                    <a href="#" class="link back" aria-label="Back">\n                        <i class="icon icon-back"></i>\n                        <span class="if-not-md">Back</span>\n                    </a>\n                </div>\n                <div class="title">Notifications</div>\n            </div>\n        </div>\n        <div class="page-content">\n\n            <!--======In Case Of No Notifications is Avilable Start==========-->\n            <div class="empty-state">\n                <img src="static/img/no_notification.svg" alt="">\n                <div class="empty-state-title">You\'re all caught up</div>\n                <div class="empty-state-sub">You have no new notifications. Offers and updates will appear here.</div>\n            </div>\n            <!--======In Case Of No Notifications is Avilable End==========-->\n\n            <div class="notif-list" style="display: none;">\n                <div class="notif-card">\n                    <div class="notif-icon">\n                        <i class="icon material-icons">local_offer</i>\n                    </div>\n                    <div class="notif-body">\n                        <div class="notif-title">Get 50% Off Instant</div>\n                        <div class="notif-desc">Use code OFF10 on every appointment</div>\n                        <div class="notif-time">Now</div>\n                    </div>\n                </div>\n                <div class="notif-card">\n                    <div class="notif-icon">\n                        <i class="icon material-icons">local_offer</i>\n                    </div>\n                    <div class="notif-body">\n                        <div class="notif-title">Get 50% Off Instant</div>\n                        <div class="notif-desc">Use code OFF10 on every appointment</div>\n                        <div class="notif-time">2 days ago</div>\n                    </div>\n                </div>\n                <div class="notif-card">\n                    <div class="notif-icon">\n                        <i class="icon material-icons">local_offer</i>\n                    </div>\n                    <div class="notif-body">\n                        <div class="notif-title">Get 50% Off Instant</div>\n                        <div class="notif-desc">Use code OFF10 on every appointment</div>\n                        <div class="notif-time">2 days ago</div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n';
      return r;
    }(this);
  },
  style: `
    .notification-page,
[data-f7-b6bb5d07a4] .notification-page .page-content { background: var(--mdoc-bg); }
[data-f7-b6bb5d07a4] .notif-list { padding: 12px 14px 24px; display: flex; flex-direction: column; gap: 10px; }
[data-f7-b6bb5d07a4] .notif-card {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        background: var(--mdoc-white);
        border: 1px solid var(--mdoc-border);
        border-radius: 14px;
        padding: 14px;
    }
[data-f7-b6bb5d07a4] .notif-icon {
        width: 40px;
        height: 40px;
        border-radius: 10px;
        background: var(--mdoc-green-soft);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }
[data-f7-b6bb5d07a4] .notif-icon .icon { color: var(--mdoc-green-dark); font-size: 20px; }
[data-f7-b6bb5d07a4] .notif-body { flex: 1; min-width: 0; }
[data-f7-b6bb5d07a4] .notif-title { font-size: 14px; font-weight: 700; color: var(--mdoc-ink); }
[data-f7-b6bb5d07a4] .notif-desc { font-size: 13px; color: var(--mdoc-muted); margin-top: 2px; line-height: 1.45; }
[data-f7-b6bb5d07a4] .notif-time { font-size: 11.5px; color: var(--mdoc-muted); margin-top: 6px; }
`,
  styleScoped: true
};